import { APIContentHeaders } from '../../system-libraries/api-types';
import { longTermToken } from '../../system-utils/events-manager';

const contentHeaders: APIContentHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

// TODO: update tests with optional headers
export const composeHeaders = (headers: Record<string, string> = {}) => ({
  ...appendClientContextHeaders(contentHeaders),
  ...headers,
});

// TODO: update tests with optional headers
export const composeHeadersWithAuthorizationToken = (token: string, headers: Record<string, string> = {}) => ({
  ...composeHeaders(headers),
  Authorization: `Bearer ${token}`,
});

export type AuthorizationHeaders<T = {}> = ReturnType<typeof composeHeadersWithAuthorizationToken> & T;

export const tryGetAuthHeaders = (): AuthorizationHeaders => {
  if (longTermToken.isTokenValid()) {
    return composeHeadersWithAuthorizationToken(longTermToken.getToken());
  }
  return null;
};

// Implementation taken from repo api api-connector-lib src/utils/header-utils.js
const getClientContext = (appId: string, userTrackingId: string): Record<string, any> => ({
  client: {
    user_tracking_id: userTrackingId || '',
    app_title: appId,
    app_package_name: 'WEB',
  },
  env: {
    platform: 'WEB',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    platform_version: navigator.appVersion || navigator.vendor || window.opera,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    make: navigator.platform || window.opera,
    locale: navigator.language,
  },
});

// Implementation taken from repo api-connector-lib src/main.js
const getAppIdFromBankId = (bankId: string): string => {
  return `${bankId} Web`;
};

// TODO: improve return type
const appendClientContextHeaders = (headers: Record<string, string>): Record<string, string> => {
  const bankId = 'CB';
  const appId = getAppIdFromBankId(bankId);
  const userTrackingId = '';

  const clientContext = getClientContext(appId, userTrackingId);
  clientContext.client = {
    ...clientContext.client,
    app_version_code: navigator.appVersion, // This header is added in repo api api-connector-lib src/utils/header-utils.js
    app_version_name: navigator.appName, // This header is added in repo api api-connector-lib src/utils/header-utils.js
  };

  return {
    ...headers,
    'x-bpi-client-context': JSON.stringify(clientContext),
  };
};
